import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import PublicLayout from "@/components/layout/PublicLayout";
import SEO from "@/components/SEO";
import { Reveal } from "@/components/motion";
import { api } from "@/lib/api";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {}); }, []);

  const schema = {
    "@context": "https://schema.org", "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
  };

  return (
    <PublicLayout>
      <SEO title="FAQ | NewStarAds YouTube Marketing" description="Frequently asked questions about NewStarAds YouTube promotion, ads management, compliance and results. Honest answers — no guaranteed-view gimmicks." schema={faqs.length ? schema : null} />
      <section className="max-w-3xl mx-auto px-5 sm:px-8 pt-16 pb-24">
        <Reveal>
          <p className="text-xs uppercase tracking-widest font-semibold text-primary">FAQ</p>
          <h1 className="mt-3 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter">Questions, answered honestly</h1>
        </Reveal>
        <Reveal delay={0.1} className="mt-10">
          <Accordion type="single" collapsible className="rounded-2xl border border-slate-200 px-5" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={f.id} value={`f${i}`}><AccordionTrigger className="text-left font-medium py-5">{f.q}</AccordionTrigger><AccordionContent className="text-slate-600 leading-relaxed pb-5">{f.a}</AccordionContent></AccordionItem>
            ))}
          </Accordion>
        </Reveal>
        <Reveal delay={0.15} className="mt-10 text-center rounded-2xl bg-slate-50 border border-slate-200 p-10">
          <h2 className="font-display text-2xl font-bold">Still have questions?</h2>
          <p className="mt-2 text-slate-600">We're happy to give you honest, no-pressure advice.</p>
          <Link to="/contact"><Button className="mt-5 rounded-full px-7">Contact us</Button></Link>
        </Reveal>
      </section>
    </PublicLayout>
  );
}
